import React from "react"
import { Link, graphql, useStaticQuery } from 'gatsby'
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"

export default function Publication() {
    const publications = useStaticQuery (
        graphql`
        query PublicationsQuery {
            books: allMicrocmsPublications(
              limit: 3
              filter: {footer_display_flag: {eq: true}, type: {eq: "書籍"}}
              sort: {fields: release_date, order: DESC}
            ) {
              edges {
                node {
                  id
                  publicationsId
                  display_image {
                    url
                  }
                  title
                }
              }
            }
            medias: allMicrocmsPublications(
              limit: 3
              filter: {footer_display_flag: {eq: true}, type: {eq: "メディア掲載"}}
              sort: {fields: release_date, order: DESC}
            ) {
              edges {
                node {
                  id
                  publicationsId
                  display_image {
                    url
                  }
                  title
                }
              }
            }
        }`
      )

    return (
      <>
        <div className="contents_01 component_publication">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
            {/*//////////////////////////////* ↓出版書籍 * //////////////////////////////*/}
              { Object.keys(publications.books.edges).length ?
                <>
                <div className="inner_title">
                  <div className="inner_title_in">
                    <h4 className="maintitle"><span>Book</span></h4>
                    <p className="subtitle"><span>出版書籍</span></p>
                  </div>
                  <div className="more"><Link to="/publication/book"><span>view more</span></Link></div>
                </div>
                <div className="publication_wrap">
                  <ul className="publication_box">
                    {publications.books.edges.map(({ node }) => (
                      <li key={node.publicationsId}>
                        <Link to={'/publication/book/' + node.publicationsId}>
                          <div className="box_gray">
                            <LazyAndPreloadImage imgUrl={node.display_image ? node.display_image.url : ''} alt="出版書籍画像" />
                          </div>
                          <p>{node.title}</p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                </>
                : ''
              }
              {/*//////////////////////////////* ↑出版書籍 * //////////////////////////////*/}

              {/*//////////////////////////////* ↓メディア掲載 * //////////////////////////////*/}
              { Object.keys(publications.medias.edges).length ?
                <>
                <div className="inner_title">
                  <div className="inner_title_in">
                    <h4 className="maintitle"><span>Media</span></h4>
                    <p className="subtitle"><span>メディア掲載</span></p>
                  </div>
                  <div className="more"><Link to="/publication/media"><span>view more</span></Link></div>
                </div>
                <div className="publication_wrap">
                  <ul className="publication_box release">
                    {publications.medias.edges.map(({ node }) => (
                      <li key={node.publicationsId}>
                        <Link to={'/publication/media/' + node.publicationsId}>
                          <div className="box_gray">
                            <LazyAndPreloadImage imgUrl={node.display_image ? node.display_image.url : ''} alt="メディア掲載画像" />
                          </div>
                          <p>{node.title}</p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                </>
                : ''
              }
              {/*//////////////////////////////* ↑メディア掲載 * //////////////////////////////*/}

            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
      </>
    )
}